import { render, staticRenderFns } from "./Theater.vue?vue&type=template&id=11650d52&"
import script from "./Theater.vue?vue&type=script&lang=js&"
export * from "./Theater.vue?vue&type=script&lang=js&"
import style0 from "./Theater.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11650d52')) {
      api.createRecord('11650d52', component.options)
    } else {
      api.reload('11650d52', component.options)
    }
    module.hot.accept("./Theater.vue?vue&type=template&id=11650d52&", function () {
      api.rerender('11650d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/Theater.vue"
export default component.exports